import styled from 'styled-components';

export const StyledMainContainer = styled.div``;
